
import React from 'react';
import { useTranslation, Trans } from 'react-i18next';
import { Layout } from '../components/common/Layout';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/common/Button';
import { SEOHead } from '../components/seo/SEOHead';



const PrivacyPage: React.FC = () => {
  const { t } = useTranslation('pages/privacy');
  const navigate = useNavigate();
  // Effective date requested: today's date
  const EFFECTIVE_DATE = '31 August 2025';
  return (
    <Layout showHeader showFooter>
      <SEOHead
        title="Privacy Policy - trAInedup.ai"
        description="Read our privacy policy to understand how trAInedup.ai collects, uses, and protects your personal information when you use our AI learning platform."
        canonical="https://trainedup.ai/privacy"
      />
      <div className="max-w-3xl mx-auto py-16 px-4">
        <Button variant="outline" onClick={() => navigate(-1)} className="mb-6">
          Back
        </Button>
        <h1 className="text-3xl font-bold mb-1">{t('title')}</h1>
        <p className="text-sm text-neutral-500 mb-6">Effective date: {EFFECTIVE_DATE}</p>
        <p className="mb-4">{t('intro')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('1_title')}</h2>
        <ul className="list-disc ml-6 mb-4">
          <li><strong>{t('1_email').split(':')[0]}:</strong> {t('1_email').split(':').slice(1).join(':').trim()}</li>
          <li><strong>{t('1_usage').split(':')[0]}:</strong> {t('1_usage').split(':').slice(1).join(':').trim()}</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('2_title')}</h2>
        <ul className="list-disc ml-6 mb-4">
          <li>{t('2_1')}</li>
          <li>{t('2_2')}</li>
          <li>{t('2_3')}</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('3_title')}</h2>
        <p className="mb-4">{t('3_text')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('4_title')}</h2>
        <p className="mb-4">{t('4_text')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('5_title')}</h2>
        <p className="mb-4">{t('5_text')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('6_title')}</h2>
        <ul className="list-disc ml-6 mb-4">
          <li>{t('6_1')}</li>
          <li>{t('6_2')}</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('7_title')}</h2>
        <p className="mb-4">{t('7_text')}</p>

        <h2 className="text-xl font-semibold mt-8 mb-2">{t('8_title')}</h2>
        <p>
          <Trans i18nKey="8_text" t={t} components={{ 1: <a href="mailto:info@trainedup.ai" className="text-primary underline">info@trainedup.ai</a> }} />
        </p>
      </div>
    </Layout>
  );
};

export default PrivacyPage;
